// extracted by mini-css-extract-plugin
export default {"flexContainer":"Map_flexContainer__onFkM","map":"Map_map__At53m","text":"Map_text__gq7QY"};